import { z } from 'zod';
import { normalizeTagName } from '../../events/normalize-tag-name.js';
export const calTagNameSchema = z
    .string()
    .trim()
    .min(1, 'Tag name is required.')
    .max(64, 'Tag name must be 64 characters or fewer.')
    .refine((name) => normalizeTagName(name) !== '', 'Tag name needs at least one letter or digit.');
//# sourceMappingURL=cal-tag-name-schema.js.map